module.exports = __webpack_public_path__ + "static/black_onyx-e2ebd7e9caea4dae12c0c0ada4d54b3e.svg";